export default {
    LIKE_BY_ADMIN: 10,
    LIKE_BY_SYSTEM: 5,
    LIKE: 1,
    DISLIKE: -1,
    SAVE: 0,
};
